import { reviews } from '@/mocks/reviews';

const bgColors = [
  'bg-accent-100/70',
  'bg-secondary-100/70',
  'bg-primary-100/70',
  'bg-accent-50/80',
  'bg-secondary-50/80',
];

export default function ReaderReviews() {
  const displayReviews = reviews.slice(0, 5);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 mb-3">
            <i className="ri-double-quotes-l text-sm"></i>
            读者口碑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            读者们怎么说
          </h2>
          <p className="mt-2 text-sm text-foreground-500">来自真实读者的评价与推荐</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {displayReviews.slice(0, 3).map((review, idx) => (
            <div
              key={review.id}
              className={`${bgColors[idx]} rounded-2xl p-5 md:p-6 flex flex-col justify-between min-h-[200px]`}
            >
              <div>
                <div className="w-8 h-8 flex items-center justify-center mb-3">
                  <i className="ri-double-quotes-l text-xl text-primary-400"></i>
                </div>
                <p className="text-sm text-foreground-800 leading-relaxed line-clamp-4">
                  "{review.content}"
                </p>
              </div>
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-foreground-200/30">
                <img
                  src={review.avatar}
                  alt={review.userName}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.userName}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-500 text-xs"></i>
                  ))}
                </div>
              </div>
            </div>
          ))}

          <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {displayReviews.slice(3).map((review, idx) => (
              <div
                key={review.id}
                className={`${bgColors[idx + 3]} rounded-2xl p-5 md:p-6 flex flex-col justify-between min-h-[180px]`}
              >
                <div>
                  <div className="w-8 h-8 flex items-center justify-center mb-3">
                    <i className="ri-double-quotes-l text-xl text-primary-400"></i>
                  </div>
                  <p className="text-sm text-foreground-800 leading-relaxed line-clamp-4">
                    "{review.content}"
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-4 pt-4 border-t border-foreground-200/30">
                  <img
                    src={review.avatar}
                    alt={review.userName}
                    className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{review.userName}</p>
                    <p className="text-xs text-foreground-500">{review.role}</p>
                  </div>
                  <div className="ml-auto flex items-center gap-0.5">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-500 text-xs"></i>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}